import React from 'react';
import { Shield, Award, Clock, ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1771856188259-7fccdeab38d2?auto=format&fit=crop&w=1920&q=70"
          alt="ItalSerrande - Serrande e sicurezza Roma"
          className="w-full h-full object-cover"
          fetchpriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-slate-900/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 py-20">
        <div className="max-w-3xl">
          {/* Italian Flag Accent */}
          <div className="flex gap-1 mb-6">
            <div className="w-16 h-1 bg-green-600"></div>
            <div className="w-16 h-1 bg-white"></div>
            <div className="w-16 h-1 bg-red-600"></div>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Sicurezza e Qualità<br />
            <span className="text-green-400">Made in Italy</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Da oltre 50 anni realizziamo serrande, tapparelle, cancelli e sistemi di sicurezza per abitazioni e attività commerciali a Roma.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button 
              onClick={() => scrollToSection('quote')}
              className="bg-green-600 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-all hover:shadow-xl font-semibold text-lg flex items-center justify-center gap-2 group"
            >
              Preventivo Gratuito
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="bg-white text-slate-900 px-8 py-4 rounded-lg hover:bg-gray-100 transition-all hover:shadow-xl font-semibold text-lg"
            >
              I Nostri Servizi
            </button>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="bg-green-600 p-3 rounded-lg">
                <Shield className="text-white" size={24} />
              </div>
              <div>
                <div className="text-white font-semibold">Garanzia</div>
                <div className="text-gray-300 text-sm">Fino a 2 anni</div>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="bg-green-600 p-3 rounded-lg">
                <Award className="text-white" size={24} />
              </div>
              <div>
                <div className="text-white font-semibold">Certificati</div>
                <div className="text-gray-300 text-sm">Prodotti sicuri</div>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="bg-green-600 p-3 rounded-lg">
                <Clock className="text-white" size={24} />
              </div>
              <div>
                <div className="text-white font-semibold">Assistenza</div>
                <div className="text-gray-300 text-sm">Disponibile 24/7</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
